import { useEffect, useState } from "react";

export function useGetIp() {
  const [ip, setIp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchIp = async () => {
      try {
        const res = await fetch("https://api64.ipify.org?format=json");
        if (!res.ok) throw new Error("Network error");

        const data = await res.json();
        if (isMounted) setIp(data.ip || null);
      } catch (err) {
        if (isMounted) setError("Failed to fetch IP");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchIp();
    return () => {
      isMounted = false;
    };
  }, []);
  return { ip, loading, error };
}

export const getPublicIP = async () => {
  const controller = new AbortController();

  // Global timeout (2 seconds max)
  const timeout = setTimeout(() => {
    controller.abort();
  }, 2000);

  const services = [
    'https://api.ipify.org',
    'https://ifconfig.me/ip',
    'https://icanhazip.com'
  ];

  try {
    const requests = services.map(url =>
      fetch(url, { signal: controller.signal })
        .then(res => res.text())
        .then(ip => ip.trim())
    );

    // ✅ Returns immediately when first one succeeds
    const ip = await Promise.any(requests);

    clearTimeout(timeout); // stop timeout if already resolved
    controller.abort();    // cancel remaining requests

    return ip;

  } catch (err) {
    // Either timeout OR all failed
    return null;
  }
};
